var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalVehicles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8333 41.1667H21.6667M49.8333 41.1667V30.3333L45.5 19.5H26L21.5583 30.2792L21.6667 41.1667M49.8333 41.1667V44.4167M21.6667 41.1667V44.4167M47.3417 28.1667H24.1583M2.16666 28.1667V39C2.16666 39.5746 2.39493 40.1257 2.80126 40.5321C3.20759 40.9384 3.75869 41.1667 4.33332 41.1667H15.1667M2.16666 28.1667V10.8333C2.16666 10.2587 2.39493 9.7076 2.80126 9.30127C3.20759 8.89495 3.75869 8.66667 4.33332 8.66667H28.1667C28.7413 8.66667 29.2924 8.89495 29.6987 9.30127C30.1051 9.7076 30.3333 10.2587 30.3333 10.8333V13M2.16666 28.1667H15.1667M9.74999 42.25L7.58332 44.4167M43.3333 34.6753H43.342V34.6667H43.3333V34.6753ZM28.1667 34.6753H28.1753V34.6667H28.1667V34.6753ZM8.66666 34.6753H8.67532V34.6667H8.66666V34.6753Z",
    stroke: "#CCCCCC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalVehicles);
export default __webpack_public_path__ + "static/media/Total_Vehicles.0c2ad9e0a1dd73f94f89ce3a404199d4.svg";
export { ForwardRef as ReactComponent };